export default __webpack_public_path__ + "static/media/eletric2.fc837675.jpeg";